import { UserManagement } from '~/enums/UserManagement';
import { rolodex } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Response {
  user_management: string;
}

// This is a super admin endpoint. Will be used when super admins are viewing other clients.
export const getIsWorkdayClient = async ({
  clientId,
}: {
  clientId: PilotId;
}): Promise<boolean> => {
  const response: Response = await rolodex.get(`/client-mapping/${clientId}`);

  return response.user_management === UserManagement.Workday;
};
